(function () {
  // Medium-sized modal (overlay + centered box) that shows the shop's own
  // Size Guide page, with this specific product's measurements spliced in
  // directly under the schematic image (replacing the page's own "-> siehe
  // 'zu den Maßen'" pointer paragraph, which would otherwise send people
  // hunting for the same numbers elsewhere) — replaces the "Passt mir der
  // Artikel?" app's full-screen drawer, which can't be pointed at our own
  // page content.
  function buildSizeGuideModal() {
    const overlay = document.createElement('div');
    overlay.className = 'onhow-size-guide-overlay';
    overlay.hidden = true;

    const modal = document.createElement('div');
    modal.className = 'onhow-size-guide-modal';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.innerHTML =
      '<button type="button" class="onhow-size-guide-modal__close" aria-label="Schließen"></button>' +
      '<div class="onhow-size-guide-modal__body"><p>L&auml;dt&hellip;</p></div>';

    document.body.appendChild(overlay);
    document.body.appendChild(modal);

    const body = modal.querySelector('.onhow-size-guide-modal__body');
    let cachedImageHtml = null;
    let cachedRestHtml = null;

    function close() {
      overlay.hidden = true;
      modal.hidden = true;
    }

    overlay.addEventListener('click', close);
    modal.querySelector('.onhow-size-guide-modal__close').addEventListener('click', close);

    async function open() {
      overlay.hidden = false;
      modal.hidden = false;

      if (cachedImageHtml === null) {
        try {
          const res = await fetch('/pages/kopie-von-grossentabelle');
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const rte = doc.querySelector('.rte');
          if (rte) {
            const image = rte.querySelector('img');
            cachedImageHtml = image && image.parentElement ? image.parentElement.outerHTML : '';
            if (image && image.parentElement) image.parentElement.remove();

            // The page's first paragraph points readers to "zu den Maßen"
            // for the A/B/C/D/E values — remove it, since we're putting
            // those values right here instead.
            const pointerParagraph = Array.from(rte.querySelectorAll('p')).find((p) =>
              p.textContent.includes('Maßangaben')
            );
            if (pointerParagraph) pointerParagraph.remove();

            cachedRestHtml = rte.innerHTML;
          } else {
            cachedImageHtml = '';
            cachedRestHtml = '<p>Die Gr&ouml;&szlig;entabelle konnte nicht geladen werden.</p>';
          }
        } catch (error) {
          cachedImageHtml = '';
          cachedRestHtml = '<p>Die Gr&ouml;&szlig;entabelle konnte nicht geladen werden.</p>';
        }
      }

      // Same assumption already used elsewhere in this file: the first
      // .product__accordion on the page is the "Maße" (measurements) one.
      let measurementsHtml = '';
      const measurementsContent = document.querySelector('.product__accordion .accordion__content');
      if (measurementsContent && measurementsContent.textContent.trim()) {
        measurementsHtml =
          '<div class="onhow-size-guide-modal__measurements">' +
          '<p class="onhow-size-guide-modal__measurements-title">Ma&szlig;e f&uuml;r diesen Artikel</p>' +
          measurementsContent.innerHTML +
          '</div>';
      }

      body.innerHTML = cachedImageHtml + measurementsHtml + cachedRestHtml;
    }

    return { open, close };
  }

  function buildQuicklinksRow() {
    const productForm = document.querySelector('main product-form');
    if (!productForm || !productForm.parentElement) return;

    const row = document.createElement('div');
    row.className = 'product-quicklinks';
    let inserted = false;

    function ensureInserted() {
      if (inserted) return;
      inserted = true;
      productForm.parentElement.insertBefore(row, productForm);
    }

    const measurementsAccordion = document.querySelector('.product__accordion');
    if (measurementsAccordion) {
      const link = document.createElement('button');
      link.type = 'button';
      link.className = 'product-quicklinks__measurements';
      link.textContent = 'Zu den Maßen';
      link.addEventListener('click', () => {
        const details = measurementsAccordion.querySelector('details');
        if (details) details.open = true;
        measurementsAccordion.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      row.appendChild(link);
      ensureInserted();
    }

    const sizeGuideModal = buildSizeGuideModal();

    // The app's own button ("Passt mir der Artikel?") is kept in the DOM
    // (hidden) rather than removed, so the app doesn't lose track of it —
    // a plain replacement button next to it, styled the same as "Zu den
    // Maßen", opens our own modal instead of the app's full-screen drawer.
    function attachSizeToggle(toggle) {
      row.appendChild(toggle);
      // The app's own CSS rule for this element is itself "display:
      // inline-flex !important", which a plain inline style can't override —
      // needs a class-based rule with higher specificity (see CSS file).
      toggle.classList.add('onhow-app-toggle-hidden');

      const replacement = document.createElement('button');
      replacement.type = 'button';
      replacement.className = 'product-quicklinks__measurements';
      replacement.textContent = 'Passt mir der Artikel?';
      replacement.addEventListener('click', () => sizeGuideModal.open());

      toggle.insertAdjacentElement('afterend', replacement);
      ensureInserted();
    }

    const existingToggle = document.querySelector('[class*="size-toggle-template"]');
    if (existingToggle) {
      attachSizeToggle(existingToggle);
    } else {
      const observer = new MutationObserver(() => {
        const toggle = document.querySelector('[class*="size-toggle-template"]');
        if (toggle) {
          attachSizeToggle(toggle);
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), 8000);
    }
  }

  // Expands upward: the info panel is inserted before the bar in the DOM, so
  // showing it makes it appear stacked directly above the bar (no
  // overlay/modal). Closed via its own top-right X button.
  function buildAuthenticityBar() {
    const gallery = document.querySelector('main media-gallery');
    if (!gallery) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'authenticity-bar-wrapper';

    const panel = document.createElement('div');
    panel.className = 'authenticity-bar__panel';
    panel.hidden = true;
    panel.innerHTML =
      '<button type="button" class="authenticity-bar__close" aria-label="Schließen">&times;</button>' +
      '<p>Jedes Teil wird vor dem Versand von uns auf Echtheit gepr&uuml;ft. Durch unsere Erfahrung mit Vintage-Markenware erkennen wir F&auml;lschungen zuverl&auml;ssig. So kannst du sicher sein, dass du bei uns immer ein zu 100&nbsp;% originales Produkt bekommst.</p>';

    const bar = document.createElement('div');
    bar.className = 'authenticity-bar';
    bar.innerHTML =
      '<span class="authenticity-bar__title">Echtheits-Garantie</span>' +
      '<button type="button" class="authenticity-bar__info" aria-expanded="false">' +
      'Mehr Infos' +
      '<span class="authenticity-bar__info-icon">i</span>' +
      '</button>';

    wrapper.appendChild(panel);
    wrapper.appendChild(bar);

    const infoButton = bar.querySelector('.authenticity-bar__info');
    const closeButton = panel.querySelector('.authenticity-bar__close');

    function toggle(show) {
      panel.hidden = !show;
      infoButton.setAttribute('aria-expanded', String(show));
    }

    infoButton.addEventListener('click', () => toggle(panel.hidden));
    closeButton.addEventListener('click', () => toggle(false));

    gallery.appendChild(wrapper);
  }

  function updateTaxCaption() {
    const taxCaption = document.querySelector('main .product__tax');
    if (!taxCaption) return;
    taxCaption.textContent = 'inkl. MwSt. zzgl. Versandkosten';
  }

  function buildTrustBadges() {
    const firstAccordion = document.querySelector('.product__accordion');
    if (!firstAccordion || !firstAccordion.parentElement) return;

    const wrap = document.createElement('div');
    wrap.className = 'product-trust-badges';
    wrap.innerHTML =
      '<div class="product-trust-badges__item">' +
      '<span class="svg-wrapper">' + (window.__truckIcon || '') + '</span>' +
      '<span>Kostenloser Versand ab 75 €</span>' +
      '</div>' +
      '<div class="product-trust-badges__item">' +
      '<span class="svg-wrapper">' + (window.__returnIcon || '') + '</span>' +
      '<span>14 Tage Rückgaberecht</span>' +
      '</div>';

    firstAccordion.parentElement.insertBefore(wrap, firstAccordion);
  }

  function init() {
    buildQuicklinksRow();
    buildAuthenticityBar();
    updateTaxCaption();
    buildTrustBadges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
